

































































import { Vue, Component, Prop } from 'vue-property-decorator';
import chatBox from '@/components/ChatBox.vue';
import loadUserManagementObjects from '@/userManagement/SampleData';

@Component({
  components: {
    chatBox,
  },
})
export default class Friend extends Vue {
  visible = false;

  doc = {};

  mounted() {
    this.$store.dispatch('bindFriends');
    this.$store.dispatch('bindChatRoom');
  }

  default = Object.freeze({
    user2: '',
    user1: '',
    partispents: [],
  })

  ChatRoom = { ...{}, ...this.default };

  sampleTest11() {
    loadUserManagementObjects(this.$store);
  }

  createCRoom(user: any) {
    // this.participants.push(
    //   this.currentUser.uid,
    //   user.uid,
    // );
    this.$store.dispatch('createChatRoom', {
      collection: 'chatRooms',
      // payload: { chatRoom: this.chatRoom },
    }).then(() => {
      this.doc = this.findChatRoom(user);
    });
    this.visible = true;
  }

  findChatRoom(user: any) {
    return this.chatRooms.find((doc: any) => (doc.chatRoom.participants.includes(user.uid) === true
      && doc.chatRoom.participants.includes(this.currentUser.uid) === true));
  }

  c(id: any) {
    this.$router.push(`/userProfile/${id}`);
  }

  get chatRooms() {
    return this.$store.state.chatRooms;
  }

  get friends() {
    return this.$store.state.friends;
  }

  get currentUser() {
    return this.$store.state.currentUser;
  }
}
